import React, { useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { getValidLocaleCode } from "@utils/localisation"
import { TableRender } from "./TableRender"
import { generateTableData } from "./helpers"

export const CategoryPricesTable = ({
  locale,
  currency,
  meanPricesByMaterial,
  countrySlug,
  language,
}) => {
  const { t } = useTranslation()

  const [tableData, setTableData] = useState(
    generateTableData(
      currency,
      meanPricesByMaterial,
      t,
      locale,
      countrySlug,
      language
    )
  )

  return (
    <div className="md:bg-white">
      <TableRender tableData={tableData} />
    </div>
  )
}
